import { IndexExpense } from "../../index-expense";
import { Category } from "../../category/category";
import { Product } from "../../product/product";
import { SubProduct } from "../../subproduct/subproduct";

export class showAddCampaignMode {
    action: string;
    product: Array<Product> | Array<SubProduct>;
    dataId:  IndexExpense;
    settings: any;
    productId: string;
    productCategoryId: string;
    Parentproduct: Array<Product>;
    productsLen: number;
    categori: Array<Category>;
    constructor (data) {
        this.action =  data.action;
        this.product =  data.product;
        this.dataId =   data.dataId;
        this.settings =  data.settings;
        this.productId =  data.productId;
        this.productCategoryId =  data.productCategoryId;
        this.Parentproduct =  data.Parentproduct;
        this.productsLen =  data.productsLen;
        this.categori =  data.categori;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/add-campaign/show-add-campaign-mode.ts